// ACompleterBlock — section « À compléter » de la fiche dossier TEF.
// CC-DEV1-17 #1 — extraite d'InfosTab et déplacée vers l'onglet Demande MPA.
// Source unique de la logique « items à compléter » (contrat/mandat/installateur
// non posés + RFR/âge manquants). VueGlobale.jsx garde sa propre liste « blocages »
// (gating pipeline) — distincte, non touchée.
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { BlockCard } from "../../../components/BlockCard";
import { getClientAge } from "../../../utils/clientFormat";

export function ACompleterBlock({ dossier }) {
  const client = dossier?.client || {};
  const rfr = client.rfr ?? client.revenu_fiscal_reference ?? null;
  const age = getClientAge(client);

  const actions = [
    !dossier?.contrat_signe && "Contrat non signé",
    !dossier?.mandat_signe && "Mandat non signé",
    !dossier?.installateur_nom && "Installateur non assigné",
    rfr == null && "Avis d'imposition manquant (RFR)",
    age == null && "CNI manquante (âge)",
  ].filter(Boolean);

  return (
    <BlockCard collapsible testId="bloc-infos-actions" title="À compléter">
      {actions.length ? (
        <div className="space-y-1">
          {actions.map((a, i) => (
            <div key={i} className="flex items-center gap-2 text-xs" style={{ color: "var(--oh-text-secondary)" }}>
              <AlertTriangle className="w-3 h-3 flex-shrink-0" style={{ color: "var(--oh-stat-amber-text)" }} /> {a}
            </div>
          ))}
        </div>
      ) : (
        <p className="text-xs flex items-center gap-2" style={{ color: "#10b981" }}><CheckCircle2 className="w-3.5 h-3.5" /> Rien à signaler.</p>
      )}
    </BlockCard>
  );
}

export default ACompleterBlock;
